import { metaSetter } from '@app/utils/meta-setter'
import { BlogWrapper } from '@app/components/blog/blog-wrapper'
import type { BlogPageProps } from '@app/types'
import { BlogLayout } from '@app/components/blog-layout'
import { Header, Header3 } from '@app/components/general/header'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { Card } from '@app/components/stateless/card/card'
import { featuredItems } from '@app/data/blog/posts'
import { Author } from '@app/components/stateless/blog/author'
import { BlogDate } from '@app/components/blog/blog-date'
import { Category } from '@app/components/stateless/card/category'
import { P } from '@app/components/stateless/typo/p'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/blog/blacklives-matters',
    }),
  }
}

const BLOG_INDEX = 7

// the filtered features - remove first two items that are featured
const featuredFilters = featuredItems.filter(
  (item) => item.category === 'accessibility' && item.index !== BLOG_INDEX
)

const blogDate =
  featuredItems.find((item) => item.index === BLOG_INDEX)?.date ?? new Date()

// Blog page - TODO: add second header with more details
function BLM(props: BlogPageProps) {
  const { t } = useTranslation('blacklives-matter')

  return (
    <BlogWrapper {...props} websiteUrl={'/blog'}>
      <div className='px-4 mx-auto container max-w-5xl space-y-8'>
        <div className='space-y-1 pt-12'>
          <BlogDate date={blogDate} />
          <div className='flex place-items-center space-x-4 py-2'>
            <Header className='p-0 md:p-0 lg:p-0 xl:p-0'>{t('header')}</Header>
            <Category category='accessibility' pure />
          </div>
          <P>{t('header-details')}</P>
        </div>

        <div className='flex flex-col place-items-center place-content-center py-5'>
          <Author
            author={t('jeff-mendez:author')}
            intro={t('jeff-mendez:intro')}
            small
            head2
          />
        </div>

        <div className='py-4'>
          <Header3 className='text-center'>{t('blog:related')}</Header3>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-3 gap-3 pb-12'>
          {featuredFilters.map(
            ({ href, category, date, backgroundImage, index }) => {
              return (
                <Card
                  key={`blog-card-${index}`}
                  category={category}
                  href={href}
                  date={date}
                  authorName='Jeff Mendez'
                  cardTitle={`features.${index}.title`}
                  cardDescription={`features.${index}.details`}
                  backgroundImage={backgroundImage}
                />
              )
            }
          )}
        </div>
      </div>
    </BlogWrapper>
  )
}

BLM.getLayout = BlogLayout

export default metaSetter(
  { BLM },
  {
    translation: 'blacklives-matter',
    gql: false,
    rest: false,
  }
)
